export default {
    host: 'https://analytics.avandromme.com',
    siteId: '2',
    trackExternalLinks: true,
}